import { TRAILER_SLOT_VALUES, TrailerSlot } from './constants';
import type { SpottedTrailerDetails, SwapBoardTrailer } from './types';

type FlattenSpottedDetailsParams = {
  slot: TrailerSlot;
  details: SpottedTrailerDetails | null | undefined;
  existingTrailer?: Partial<SwapBoardTrailer>;
};

const flattenSpottedDetailsForSlot = ({
  slot,
  details,
  existingTrailer = {},
}: FlattenSpottedDetailsParams): Record<string, unknown> => {
  if (!details) {
    return {};
  }

  return {
    [slot]: details.trailerNumber ?? existingTrailer[slot] ?? null,
    [`${slot}SpottedLatitude`]: details.spottedLatitude,
    [`${slot}SpottedLongitude`]: details.spottedLongitude,
    [`${slot}SpottedTime`]: details.spottedTime ?? null,
    [`${slot}Status`]: details.status ?? null,
  };
};

export const flattenTrailerSpottedFields = (
  trailer?: SwapBoardTrailer | null
): SwapBoardTrailer | null | undefined => {
  if (!trailer) {
    return trailer;
  }

  const spottedDetailsBySlot = Object.fromEntries(
    TRAILER_SLOT_VALUES.map((slot) => [slot, trailer[`${slot}SpottedDetails`] ?? null])
  ) as Record<TrailerSlot, SpottedTrailerDetails | null>;

  const flatFields = TRAILER_SLOT_VALUES.reduce(
    (fields, slot) => ({
      ...fields,
      ...flattenSpottedDetailsForSlot({
        slot,
        details: spottedDetailsBySlot[slot],
        existingTrailer: trailer,
      }),
    }),
    {} as Record<string, unknown>
  );

  return {
    ...trailer,
    trailer1SpottedDetails: spottedDetailsBySlot.trailer1,
    trailer2SpottedDetails: spottedDetailsBySlot.trailer2,
    ...flatFields,
  };
};
